<template>
	<div class="main-content">
		<div class="center-body">
			<Nav></Nav>
		<div class="row ph-tp abs-title" style="margin-top: 20px;padding-left: 10px;">
			品牌介绍
		</div>
		<div class="row" style="margin-top: 10px;">
			<video src="../../assets/video/aboutUsVideo.mp4" style="width: 100%;" autoplay controls muted></video>
		</div>
		<div class="row abs-title ph-tp" style="margin-top: 40px;" >
			TOMAL - 物料投加系统，固体计量专家
		</div>
		<div class="row ph-padding" style="font-size: 14px;margin-top: 15px;line-height: 2;">
			<span>普罗名特于1994年进入中国并成立了<span style="font-weight: 600;">普罗名特流体控制（上海）有限公司</span>。
			26年来，已成为中国相关行业的重要供应商和合作伙伴。秉承“立足本地、服务本地”理念，普罗名特致力于本土研发及生产，为用户提供高品质零距离的服务。目前，普罗名特在上海拥有3,300平米的管理、研发及设计中心，在全国设立了8个销售服务办事处，并在大连建立了14,000平米的计量泵、加药系统和水处理设备的生产及仓储基地。除了提供标准产品，普罗名特凭借在全球多年的工程经验，依托德国的工业制造标准，可以根据中国客户需求，提供从设计、制造、到安装、调试、运营等一系列定制服务。<br />
			普罗名特于2005年收购了瑞典一家干粉计量和聚合物制备的系统制造商TOMAL。TOMAL 创建于二十世纪五十年代初期。TOMAL的成立和发展，就是一条对创新和品质的追求之路，创始人 Tomas Alwerud 先生更是一个名副其实的发明家，在欧洲拥有众多发明创造专利，其中多螺旋精确计量喂料机就是最著名的一项，该项技术在固体物料计量领域里实现了革命性突破，直到今天依然是固体物料计量高精度的代名词。TOMAL半个多世纪以来，对于各类粉体化学品的处理、各工艺应用、系统集成性等方面积累了丰富的经验，广泛应用于各行各业。
			</span>
		</div>
		<div class="row ph-tp abs-title" style="margin-top: 30px;">
			联系我们
		</div>
		<div class="row ph-padding" style="font-size: 14px;margin-top: 15px;">
			电话：021－36360298
		</div>
		<div class="row ph-padding" style="font-size: 14px;margin-top: 10px;">
			地址：上海市闵行区陈行公路2168号8号楼
		</div>	
		<div class="row ph-padding" style="font-size: 14px;margin-top: 10px;">
			邮箱：tomal-china@tomal.se
		</div>
		<div class="row ph-padding" style="font-size: 14px;margin-top: 10px;">
			网址：www.tomal.cn
		</div>
		</div>
		
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
			}
		},
		methods: {
			route(name){
				
				if(name==3){
					this.$router.push('aboutus')
				}else if(name==1){
					this.$router.push('index')
				}
				
			}
		},
		mounted() {

		}
	}
</script>

<style lang="scss" scoped>

	.main-content {
		min-height: 100%;
		width: 100%;
		display: block;
		position: absolute;
		background: #FFF;
	}
	
	@media screen and (max-width: 980px) {
	    .center-body{	    	
	    	width: 100%;
	    	
	    	padding-bottom: 60px;
	    	
	    }
	    .main-nav{
	    	display: none;
	    }
	    .ph-padding{
	    	padding: 0 15px;
	    }
	    .ph-tp{
	    	padding: 0 5px;
	    }
	    .abs-title{
	  		font-size: 16px;
	  		margin-top: 25px;
	  		font-weight: 600;
	  	}
	   
	}
	@media screen and (min-width: 980px) {
	    .center-body{	    	
	    	width: 980px;
	    	margin: 0 auto;
	    	padding-bottom: 120px;
	    	
	    }
	    .nav-title{
	    	font-size: 30px;
	    	height: 60px;
	    	padding-top: 10px;
	    	width: 160px;
	    	text-align: center;
	    	border-bottom: 1px solid #dcdee2;
	    	flex: none;
	    	
	    }
	    .nav-right{	    	
	    	height: 60px;
	    	border-bottom: 1px solid #dcdee2;
	    	
	    }
	    .ivu-menu-item{
	    	width: 120px;
	    	text-align: center;
	    }
	  	.abs-title{
	  		font-size: 20px;
	  		margin-top: 25px;
	  		font-weight: 600;
	  	}
	}
</style>